import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityVariation } from "../../entity/EntityVariation";

export class DtoVariationsGetRes extends EntityVariation {
  public items: EntityVariation[]  = [];
}
